<div class="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-800 lg:px-6 md:px-2 px-6 pb-4 h-screen overflow-x-hidden">
  <div class="flex h-16 shrink-0 items-center">
    <img class="mt-6 rounded-3xl w-auto lg:block md:hidden" src="assets/logo.png" alt="UnionCoop" />
    <img class="mt-6 rounded-4xl w-auto md:block lg:hidden hidden" src="assets/logo1.png" alt="UnionCoop" />
  </div>
  <nav class="flex flex-1 flex-col mt-8">
    <ul role="list" class="flex flex-1 flex-col gap-y-7 lg:items-stretch md:items-center">
      <li>
        <ul role="list" class="-mx-3 space-y-1">
          @for (item of filteredMenuItems(); track item.path) {
            <li>
              <button
                (click)="navigate(item.path)"
                [ngClass]="{ 'bg-gray-700 text-primary': isActive(item.path) }"
                class="group w-full flex gap-x-3 rounded-xl p-2 text-sm/6 text-gray-300 hover:bg-gray-700 hover:text-primary cursor-pointer"
              >
                @if (item.icon) {
                  <fa-icon class="text-center w-6 text-lg" [icon]="item.icon"></fa-icon>
                }
                <span class="lg:block md:hidden mt-1">{{ item.label }}</span>
              </button>
            </li>
          }
        </ul>
      </li>
      <li class="-mx-6 -mb-4 mt-auto">
        <div class="hover:bg-gray-700">
          <app-profile id="Menu" [isSideMenu]="true"></app-profile>
        </div>
      </li>
    </ul>
  </nav>
</div>
